import React from 'react';

function Shipping() {
  return <div>Shipping</div>;
}

export default Shipping;
